import { ProductScreenshot } from 'components/ProductScreenshot';
import { CalloutBox } from 'components/Docs/CalloutBox';
import * as React from 'react';
export default {
  ProductScreenshot,
  CalloutBox,
  React
};